import { Bot } from 'lucide-react';
import { cn } from '@scio3/ui';
import { OPTIBOT_GRADIENT } from '../utils/constants';

/**
 * OptiBot avatar — green gradient circle with a bot icon. Defaults to 28px
 * (next to assistant/welcome messages); pass `className`/`iconClassName` to
 * enlarge it (e.g. the welcome hero).
 */
export function BotAvatar({
  className,
  iconClassName,
}: {
  className?: string;
  iconClassName?: string;
}) {
  return (
    <div
      className={cn('flex h-7 w-7 shrink-0 items-center justify-center rounded-full', className)}
      style={{ background: OPTIBOT_GRADIENT }}
    >
      <Bot className={cn('h-4 w-4 text-white', iconClassName)} />
    </div>
  );
}
